import FundApp from './FundApp';

export default FundApp;
